export default {
  contact: null,
  contacts: null,
  newContacts: null,
  unsubscribeGetContact: null,
  documentTypes: ["DNI", "Carnet de extranjería", "RUC", "Pasaporte"],
};
